/* petso-talentail-online-gwp-v1 */
(() => {
  const offerByVariant = {
    "44819229671667": { gifts: [{ id: "45966300053747", group: "one-point-five-chicken" }, { id: "45966300119283", group: "one-point-five-beef" }, { id: "45966300184819", group: "one-point-five-lamb" }] },
    "44947999228147": { gifts: [{ id: "45966300053747", group: "one-point-five-chicken" }, { id: "45966300119283", group: "one-point-five-beef" }, { id: "45966300184819", group: "one-point-five-lamb" }] },
    "45694440374515": { gifts: [{ id: "47061318959347", group: "five-mousse" }, { id: "45966300053747", group: "five-chicken" }, { id: "45966300250355", group: "five-venison" }, { id: "45966300119283", group: "five-beef" }, { id: "45966300184819", group: "five-lamb" }] },
    "45694438867187": { gifts: [{ id: "47061318959347", group: "five-mousse" }, { id: "45966300053747", group: "five-chicken" }, { id: "45966300250355", group: "five-venison" }, { id: "45966300119283", group: "five-beef" }, { id: "45966300184819", group: "five-lamb" }] }
  };

  const number = (value, fallback = 1) => {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
  };

  // Dynamic/accelerated payment sends a product directly to checkout and does
  // not reliably pass through the normal cart-add request that adds gifts.
  // For these two promotion PDPs, retain only the explicit Add to cart route.
  const hideAcceleratedCheckout = () => {
    document.querySelectorAll('form[action^="/cart/add"]').forEach((form) => {
      const idInput = form.querySelector('[name="id"]');
      if (!offerByVariant[String(idInput?.value || '')]) return;
      const root = form.closest('.product__info-container') || form.parentElement || document;
      root.querySelectorAll('.shopify-payment-button').forEach((button) => {
        button.setAttribute('hidden', 'hidden');
        button.style.display = 'none';
      });
    });
  };
  hideAcceleratedCheckout();
  new MutationObserver(hideAcceleratedCheckout).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener("submit", async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[action^="/cart/add"]')) return;
    const idInput = form.querySelector('[name="id"]');
    const offer = offerByVariant[String(idInput?.value || "")];
    if (!offer) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const submit = form.querySelector('[type="submit"]');
    if (submit) {
      submit.setAttribute("aria-disabled", "true");
      submit.disabled = true;
    }

    const quantity = number(form.querySelector('[name="quantity"]')?.value);
    const items = [
      { id: String(idInput.value), quantity },
      ...offer.gifts.map((gift) => ({
        id: gift.id,
        quantity,
        properties: {
          "_petso_talentail_promo_gift": gift.group,
          "_petso_talentail_offer": "TALENTAIL bonus 180g can"
        }
      }))
    ];

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items })
      });
      const body = await response.json();
      if (!response.ok) throw new Error(body.description || body.message || "Unable to add the bonus cans.");
      window.location.assign("/cart");
    } catch (error) {
      window.alert(error.message || "Unable to add the bonus cans. Please try again.");
      if (submit) {
        submit.removeAttribute("aria-disabled");
        submit.disabled = false;
      }
    }
  }, true);
})();
